
const { site } = window.tg;

import Alpine from 'alpinejs'
import screen from '@alpine-collective/toolkit-screen'
import collapse from '@alpinejs/collapse'
import intersect from '@alpinejs/intersect'
import Hammer from 'hammerjs'
import Choices from 'choices.js';
import dayjs from 'dayjs'
import Swiper from "swiper"
import 'dayjs/locale/af'
import yearDropdownPlugin from './integration/flatpickr-year-dropdown-plugin';

// Alpine Components
import searchAutocomplete from './alpine-components/search-autocomplete.js';
import searchDatePickerStart from './alpine-components/search-start.js';
import searchDatePickerEnd from './alpine-components/search-end.js';
import searchGuest from './alpine-components/search-guest.js';
import searchMembership from './alpine-components/search-membership.js';
import bottomTray from './alpine-components/bottom-tray.js';
import updateReactionsCount from './alpine-components/update-reactions-count.js'

import flatpickr from "@hoektoe/flatpickr-af";
import { Afrikaans } from "@hoektoe/flatpickr-af/dist/l10n/af.js";
const {
    language_switch
} = window.tg;

window.hammer = Hammer;
window.Swiper = Swiper
window.yearDropdownPlugin = yearDropdownPlugin;
window.Choices = Choices;
window.Alpine = Alpine
window.dayjs = dayjs;
window.flatpickr = flatpickr

// Set language for flatpickr globally
if (language_switch == 'af') {
    window.dayjs.locale('af')
    window.flatpickr.localize(Afrikaans)
}

Alpine.plugin(collapse)
Alpine.plugin(screen)
Alpine.plugin(intersect)

import './store/auth'
import './store/general'
import './store/search'
import './store/results'
import './store/review.js'

window.searchAutocomplete = searchAutocomplete
window.searchDatePickerStart = searchDatePickerStart
window.searchDatePickerEnd = searchDatePickerEnd
window.searchGuest = searchGuest
window.searchMembership = searchMembership
window.updateReactionsCount = updateReactionsCount

if (site === 'ls') {
    window.bottomTray = bottomTray;
}

Alpine.start()
